var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"terminal-input"}},[_c('input',{attrs:{"id":"fake-input","type":"text"}}),_c('TerminalPWDUser',{attrs:{"username":_vm.username,"pwd":_vm.pwd}}),_c('TerminalEditableWrapper',{attrs:{"suggestions":_vm.suggestions,"cursorIndex":_vm.cursorIndex,"editableText":_vm.editableText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }